import { FormalityCodeNameEnum } from '../enums/formality-code-name.enum';
import { AccountsApproval } from '../models/accounts-approval';
import { CapitalDepositFormality } from '../models/capital-deposit-formality';
import { CapitalIncomeDeclaration } from '../models/capital-income-declaration';
import { CreationFormality } from '../models/creation-formality';
import { Formality, FormalityJson } from '../models/formality';
import { FormalityBase } from '../models/formality-base';

export class FormalityHelper {
  static fromUnknownFormalityJson(json: FormalityJson): Formality {
    switch (json.code_name) {
      case FormalityCodeNameEnum.companyCreation:
        return CreationFormality.fromJson(json);
      case FormalityCodeNameEnum.accountsApproval:
        return AccountsApproval.fromJson(json);
      case FormalityCodeNameEnum.capitalDeposit:
        return CapitalDepositFormality.fromJson(json);
      case FormalityCodeNameEnum.capitalIncomeDeclaration:
        return CapitalIncomeDeclaration.fromJson(json);
      default:
        return FormalityBase.fromJson(json);
    }
  }

  static toUnknownFormalityJson(formality: Formality): FormalityJson {
    switch (formality.codeName) {
      case FormalityCodeNameEnum.companyCreation:
        return CreationFormality.toJson(formality);
      case FormalityCodeNameEnum.accountsApproval:
        return AccountsApproval.toJson(formality);
      case FormalityCodeNameEnum.capitalDeposit:
        return CapitalDepositFormality.toJson(formality);
      case FormalityCodeNameEnum.capitalIncomeDeclaration:
        return CapitalIncomeDeclaration.toJson(formality);
      default:
        return FormalityBase.toJson(formality);
    }
  }
}
